module.exports = __webpack_public_path__ + "static/media/id_card.a3ff23fb.png";